module.exports = __webpack_public_path__ + "static/assets/a627547ae2944bc62946c205593fd1e2.png";